export default __webpack_public_path__ + "static/media/logo192x192.508cc611.png";